import $ from 'jquery';
import ReactDOM from 'react-dom';
import React from 'react';

import loadData from '../../lib/bootstrapped_data';
import HereMap from '../../components/here_maps/HereMap.jsx';
import Area from '../../components/here_maps/layers/Area.jsx';

const AdministrationRestrictedAreas = {
  init() {
    this.renderMaps();
  },

  renderArea() {
    const restrictedAreas = loadData('restricted_areas').data;
    if (!restrictedAreas && restrictedAreas.length === 0) return null;

    return restrictedAreas.map((restrictedArea) => (
      <Area
        key={restrictedArea.id}
        area={restrictedArea.area_type === 'bbox' ? restrictedArea.bounding_box : restrictedArea.area}
        color="#ff2b79"
        opacity={0.8}
        fillColor="#ff2b79"
      />
    ));
  },

  renderMaps() {
    const mapEl = $('#js-map-container');
    if (!mapEl.length) return;

    ReactDOM.render(
      <HereMap autoZoom noTraffic boundingBox={loadData('bbox')}>
        {this.renderArea()}
      </HereMap>,
      mapEl.get(0)
    );
  }
}

export default AdministrationRestrictedAreas;
